import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import fa_IR from "antd/lib/locale/fa_IR";

// router
import { BrowserRouter } from "react-router-dom";

// redux
import { store } from "./store";
import { Provider } from "react-redux";
import { Main } from "./Main";

// styles
import "antd/dist/antd.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./assets/styles/utils/animate.css";
// import "./assets/styles/utils/fontawesome.min.css";
import "./assets/styles/utils/fontawesome2.min.css";
import "./assets/styles/main.min.css";

ReactDOM.render(
  <ConfigProvider direction="ltr">
    <Provider store={store}>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </Provider>
  </ConfigProvider>,
  document.getElementById("root")
);
